export const ROUTE_NAME_DICT = [
  {
    name: 'activityAdd',
    path: 'activity_choose_template'
  },
  {
    name: 'basicInfo',
    path: 'activity_basic_info'
  },
  {
    name: 'detail',
    path: 'activity_details'
  },
  // {
  //   name: 'tags',
  //   path: 'activity_tag_details'
  // },
  {
    name: 'special',
    path: 'activity_spu_details'
  },
  // {
  //   name: 'fnb',
  //   path: 'activity_fnb_details'
  // },
  // {
  //   name: 'hotelVoucher',
  //   path: 'activity_hotel_details'
  // },
  {
    name: 'notes',
    path: 'activity_operational_info'
  },
  {
    name: 'packageBasicInfo',
    path: 'package_info'
  },
  {
    name: 'packageDetail',
    path: 'package_details'
  },
  // {
  //   name: 'fnb_content',
  //   path: 'package_fnb_content'
  // },
  {
    name: 'packageExtra',
    path: 'package_extra_time'
  },
  {
    name: 'packageSchedule',
    path: 'package_price'
  },
  // {
  //   name: 'schedule',
  //   path: 'package_create_timeslot'
  // },
  {
    name: 'xinfo',
    path: 'package_extra_info'
  },
  {
    name: 'financial_model',
    path: 'package_financial_model'
  }
]

export const GTM_COUNTER_KEY = 'activity_gtm_counter_'

const MAX_AGE = 1000 * 60 * 60 * 24 * 30 // 30 days expires

const LIFECYCLE = (1000 * 60) & (60 * 8) // Clean up stale data on a regular basis

const getStorage = function(key = GTM_COUNTER_KEY) {
  let activity_counter = localStorage.getItem(key)

  return (activity_counter && JSON.parse(activity_counter)) || {}
}

const nextTick = function(handleNext) {
  let timerFunc
  let counter = 1
  let observer = new MutationObserver(handleNext)
  let textNode = document.createTextNode(counter)
  let currentTimestamp = 0
  observer.observe(textNode, {
    characterData: true
  })

  timerFunc = function() {
    counter = (counter + 1) % 2
    textNode.data = counter
    currentTimestamp = +new Date()
  }

  return function() {
    if (currentTimestamp + LIFECYCLE <= +new Date()) {
      timerFunc()
    }
  }
}

const clearStorageTimer = (function() {
  return nextTick(function() {
    let activity_counter = getStorage()
    activity_counter = Object.entries(activity_counter).reduce((acc, curr) => {
      let [key, val] = curr
      if (val.expires && val.expires + MAX_AGE < +new Date()) {
        // expires
        return acc
      }

      val.expires = val.expires || +new Date()
      return {
        ...acc,
        [key]: val
      }
    }, {})

    localStorage.setItem(GTM_COUNTER_KEY, JSON.stringify(activity_counter))
  })
})()

export const getCounterStorage = function(activityId, name, increase = true) {
  let activity_counter = getStorage()
  let currentCounter = _.get(activity_counter, `${activityId}.${name}`, 0)
  let value = increase ? currentCounter + 1 : currentCounter
  _.set(activity_counter, `${activityId}.${name}`, value)
  _.set(activity_counter, `${activityId}.expires`, +new Date())

  localStorage.setItem(GTM_COUNTER_KEY, JSON.stringify(activity_counter))

  return value
}

// https://docs.google.com/spreadsheets/d/1eAefifMl0oFegOgJUh8S4PpCHou2g7Ynkdcqf4ZaUIk/edit#gid=0
export const saveTrackEventCustom = async function({
  event = 'virtualPageView',
  // virtualPageView
  previousPageUrl = 'none',
  // trackEventCustom
  eventAction = 'none',
  groupId = 'none', // Save In-Page Selection
  isBtnSave = false,
  customPath = undefined
} = {}) {
  // DataLayer distinguishes merchant and admin platform
  // Need to filter out BD audit on admin platform
  if (klook.getPlatformRoleKey() !== 'bd_audit' && window.dataLayer) {
    if (!['trackEventCustom', 'virtualPageView'].includes(event)) {
      throw new TypeError('Error Event Type')
    }

    let name = this.$route.name
    let includesDict = _.find(ROUTE_NAME_DICT, {
      name
    })

    if (includesDict) {
      let activity_id = +this.$route.params.id
      let { template_id, sub_category_id } =
        (await this.$store.dispatch('getActCategory2action', {
          activity_id
        })) || {}

      let { package_id, model } = this.$route.query
      let packageId = isNaN(package_id) ? 'none' : +package_id

      let path = ''
      switch (model) {
        case 'tags':
          path = 'activity_tag_details'
          break
        case 'fnb_menu':
          path = 'activity_fnb_details'
          break
        case 'hotel_voucher':
          path = 'activity_hotel_details'
          break
        default:
          path = customPath || includesDict.path
      }

      let isPackagePage = -1 !== path.indexOf('package')
      let pageUrl = isBtnSave ? path + '/save' : path
      let storageValue = isPackagePage ? `${pageUrl}:${packageId}` : pageUrl

      let data = {
        event,
        pageUrl: `${window.KLK_LANG}/act/${pageUrl}`,
        activityId: activity_id,
        templateId: template_id,
        tagId: sub_category_id,
        ...(isPackagePage
          ? {
              packageId
            }
          : {})
      }

      if (event === 'virtualPageView') {
        // Click the save button multiple times on the current page, the counter does not need to be added repeatedly
        let session = sessionStorage.getItem(GTM_COUNTER_KEY) || ''
        let invalid = false

        if (!isBtnSave && -1 !== session.indexOf(pageUrl)) {
          if (isPackagePage) {
            let cachePackageId = session.split(':')[1] || 0
            if (packageId === +cachePackageId) {
              invalid = true
            }
          } else {
            invalid = true
          }
        }

        if (
          session &&
          ((isBtnSave && session === storageValue) || // If the save button is triggered and not for the first time, emit gtm is not required
            invalid) // If it is not triggered by save button, and this page is same, it does not emit gtm
        ) {
          return
        }

        sessionStorage.setItem(GTM_COUNTER_KEY, storageValue)

        data = {
          ...data,
          previousPage: previousPageUrl,
          onboardingCounter: getCounterStorage(activity_id, storageValue)
        }
      } else {
        data = {
          ...data,
          eventAction,
          eventCategory: path,
          ...(eventAction === 'Save In-Page Selection'
            ? { eventLabel: isNaN(groupId) ? 'none' : groupId }
            : {})
        }
      }
      console.log('Activity Onboarding Tracking \n', data)
      window.dataLayer.push(data)
      clearStorageTimer()
    }
  }
}

export const GTMHookItem = (tags) => {
  if (klook.getPlatformRoleKey() !== 'bd_audit' && window.dataLayer && typeof tags === 'string') {
    const item = {
      event: 'trackEventCustom'
    }
    const tagsArr = tags.split('|')
    item.eventCategory = tagsArr[0]
    item.eventAction = tagsArr[1]
    item.eventLabel = tagsArr[2] == 'undefined' ? undefined : tagsArr[2]
    item.eventValue = tagsArr[3]
    typeof window.dataLayer.push === 'function' && window.dataLayer.push(item)
  }
}
